



































import { Component, Vue, Emit } from 'vue-property-decorator'
import { QueryIncomeDetail, QueryIncomeFileList, QueryPlatformOperatingIncome } from '@/api'

@Component({
  components: {},
})
export default class InvestorIncomeDialog extends Vue {
  private show = false
  private data: any = {}
  private monthOptions: Array<any> = []
  private month = ''
  // 平台运营数据
  private poi: any = {}
  // 投资明细
  private incomes: Array<any> = []

  private notData = false

  @Emit('close')
  private close() {
    this.show = false
    this.data = {}
    this.defaultData()
    this.notData = false
  }
  private defaultData() {
    this.poi = {
      areaDeviceIncomeList: [{ area: '', deviceNumber: '', deviceIncomeValue: 0, privateDomainIncomeValue: 0 }],
      liveStreamingIncomeList: [
        { name: '直播间1', incomeValue: 0 },
        { name: '直播间2', incomeValue: 0 },
        { name: '直播间3', incomeValue: 0 },
      ],
      goodsCategoryIncomeList: [
        {
          category: '药食同源',
          incomeValue: 0,
        },
        {
          category: '滋养补品',
          incomeValue: 0,
        },
        {
          category: '护肤养颜',
          incomeValue: 0,
        },
        {
          category: '宝妈常备',
          incomeValue: 0,
        },
        {
          category: '幸福生活',
          incomeValue: 0,
        },
        {
          category: '医疗器械',
          incomeValue: 0,
        },
      ],
    }
    this.incomes = [
      { incomeType: 1, incomeValue: 0 },
      { incomeType: 2, incomeValue: 0 },
      { incomeType: 3, incomeValue: 0 },
    ]
  }
  private async created() {
    this.defaultData()
    await this.loadMenthOptions()
  }

  public async open(data: any) {
    this.show = true
    this.data = data || {}
    this.notData = false
    this.defaultData()
    if (!this.month && this.monthOptions.length > 0) {
      this.month = this.monthOptions[0].value
    }
    await this.loadData()
  }

  private async loadMenthOptions() {
    try {
      const fl = await QueryIncomeFileList({})
      const list = fl && fl.list ? fl.list : []
      this.monthOptions = list.map((e: any) => ({
        label: e.month,
        value: e.month,
      }))
      this.month = this.monthOptions.length > 0 ? this.monthOptions[0].value : ''
    } catch {
      this.monthOptions = []
      this.month = ''
    }
  }

  private async loadData() {
    if (!this.data || !this.data.userNo || !this.month) {
      this.notData = true
      return
    }
    this.notData = false
    const param = { investorUserNo: this.data.userNo, month: this.month }
    const qidRes = await QueryIncomeDetail(param)
    const qpoiRes = await QueryPlatformOperatingIncome(param)
    const detailList = qidRes && qidRes.list ? qidRes.list : []
    if (detailList.length > 0) {
      this.poi = qpoiRes || this.poi
      this.incomes = detailList
      this.notData = false
    } else {
      this.defaultData()
      this.notData = true
    }
  }

  private selectChange() {
    this.loadData()
  }

  public async save() {
    console.log('s')
  }
}
